<div class="cabecalho__infos">
  <div class="cabecalho__infos__detalhes">
    <span class="titulo__info">CLIENTE: {{cliente}} </span>
    <span class="titulo__info">CONTRATO: {{contrato}}</span>
  </div>
  <div class="cabecalho__infos__detalhes">
    <span class="titulo__info">CNPJ: {{cnpj}}</span>
    <span class="titulo__info">TIPO DE CONTRATO: {{tipoDeContrato}}</span>
  </div>
  <div class="cabecalho__infos__detalhes">
    <span class="titulo__info">MÊS DE REFERÊNCIA: {{mesReferencia}} </span>
    <span class="titulo__info">VENCIMENTO: {{vencimento | date: "dd/MM/yyyy"}} </span>
  </div>
  <div class="cabecalho__infos__detalhes">
    <span class="titulo__info">FATURA No: {{faturaNumero}} </span>
    <span class="titulo__info">VALOR: {{valor}} </span>
  </div>
  <div class="cabecalho__infos__detalhes">
    <span class="titulo__info">Data de Emissão: {{dataEmissao | date: "dd/MM/yyyy"}} </span>
    <span class="titulo__info">Emissão: {{ emissao | date: "dd/MM/yyyy"}} </span>
  </div>
</div>
<div class="div__espaco">
</div>
<div class="detalhamento__extrato">
  <p class="detalhamento">DETALHAMENTO - EXTRATO DE LOCAÇÃO</p>
</div>
